import React from 'react';
import { Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab, Grid, Divider } from '@material-ui/core'
import SpecificComponent from '../../commons/SpecificComponent';







export default class PlanificareDialog extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {

    }


    render() {
        return (
            <div>
                <Dialog
                    className="pm-alert-dialog"
                    disableEscapeKeyDown
                    open={this.props.open}
                    onClose={this.props.dialogClose}
                    style={{ zIndex: 6000 }}
                    maxWidth={'xs'}
                >
                    <DialogActions >
                        <Fab onClick={this.props.dialogClose} className="pm-round-button-dialog">
                            <i className='material-icons pm-round-button-text-dialog'>close</i>
                        </Fab>
                    </DialogActions>


                    <DialogContent>
                        <Grid container>

                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container>
                                    <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <span style={{ marginRight: 20, fontSize: 18, display: 'block', fontWeight: 600 }}>{this.dictionary.financiar.planificareVenituri} {this.props.prognozat.an}</span>
                                    </Grid>

                                    <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        {/* <span style={{ marginRight: 20, fontSize: 14, display: 'block' }}>{this.props.factura.localitate}</span> */}
                                    </Grid>

                                </Grid>

                                <Divider style={{ marginTop: 20 }} className="pm-divider" />
                            </Grid>


                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container>
                                    <Grid style={{ marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <div style={{ position: 'relative', textAlign: 'left' }}>
                                            <input
                                                style={{ fontSize: 14, fontWeight: 400, width: '90%', }}
                                                id='valoare'
                                                type="text"
                                                step='any'
                                                className='add-project-input'
                                                placeholder={'Valoare Prognoza'}
                                                margin="normal"
                                                name='valoare'
                                                value={this.props.prognozat.valoare || ''}
                                                onChange={this.props.changePrognoza}
                                            // onBlur={this.props.updateAngajatData}
                                            />
                                            <label className='inputLabelPM' htmlFor='telefon'>{this.dictionary.financiar.lei}</label>
                                        </div>

                                    </Grid>



                                    <Grid style={{ marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Button
                                            style={{ width:'100%' }}

                                            className={'add-button-green'} onClick={() => { this.props.salveazaPrognoza() }}  >

                                             {this.dictionary.financiar.salveaza}
                                        </Button>

                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>
                    </DialogContent>

                    {/* <h2 className='pm-dialog-alert-title'>{this.props.title}</h2> */}
                    {/* <DialogActions className="pm-dialog-bottom-buttons">




                    </DialogActions> */}


                </Dialog>
            </div>
        );
    }
}